import * as React from 'react';

import {FieldData, FormContext, FormGroup} from './FormContext';

type FormCheckboxProps = {
    field: FieldData;
    group: FormGroup;
};

// tslint:disable-next-line function-name
export function FormCheckbox(props: FormCheckboxProps): JSX.Element {
    const {data, dispatch} = React.useContext(FormContext);

    function onChange(event: React.FormEvent): void {
        let value: string[] = Array.isArray(props.field.value)
            ? props.field.value
            : [];
        const el: HTMLInputElement = event.target as HTMLInputElement;

        if (el.checked) {
            value = value.concat(el.value);
        } else {
            value = value.filter((i: string): boolean => i !== el.value);
        }

        dispatch({
            type: 'SET',
            payload: {
                group: props.group,
                name: props.field.name,
                value,
            },
        });
    }

    const labelError: string =
        props.field.choices?.length === 1 && props.field.error ? 'error' : '';

    return (
        <div className="c-review-form__row">
            <h2
                className={`c-review-form__label ${
                    props.field.error ? 'error' : ''
                }`}
            >
                {props.field.title}
            </h2>
            {props.field.choices?.map(
                (choice: string, index: number): JSX.Element => {
                    return (
                        <label
                            key={index}
                            className={`c-review-form__label  c-review-form__label--checkbox ${labelError}`}
                        >
                            <input
                                type="checkbox"
                                name={props.field.name}
                                aria-checked={false}
                                value={index}
                                onChange={onChange}
                            />
                            {choice}
                        </label>
                    );
                },
            )}
        </div>
    );
}
